import Box from '@mui/material/Box';
import { Fab, Zoom, useScrollTrigger, styled } from '@mui/material';
import { HiOutlineArrowNarrowUp, } from "react-icons/hi";
import BKImageDashboard from "assets/images/Parallax/SessionG/BK_Dashboard.png";
import MenuAll from "./MenuAll";

const ContainerBG = styled("div")({
    backgroundImage: `linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${BKImageDashboard})`,
    backgroundPositionX: "center",
    backgroundPosittionY: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed"
});

const Content = (props) => {
    return (
        <ContainerBG>
            <MenuAll />
            <Box>
                {/* <Box component="main" sx={{ flexGrow: 1, p: 3, mt:"50px", width: '100%' }}></Box> */}
                <div className="backgournd-content-children">
                    {props.children}
                </div>

                <ScrollToTop>
                    <Fab
                        color="error"
                        size="large"
                        sx={{
                            flexDirection: "column",
                            borderRadius: "16px",
                            width: "35px",
                            height: "70px",
                            textAlign: "center",
                            lineHeight: "1",
                            fontSize: "13px",
                            backgroundColor: "#ff0000"
                        }}
                    >
                        <HiOutlineArrowNarrowUp size="25" />
                        <span style={{ marginTop: '8px', textTransform: 'uppercase', color: 'white' }}>
                            UP
                        </span>
                    </Fab>
                </ScrollToTop>
            </Box>
        </ContainerBG>
    )
}
export default Content;

const ScrollToTop = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 300,
    });

    const handleClick = (event) => {
        window.scrollTo({ top: 0, behavior: `smooth` })
    };

    return (
        <Zoom in={trigger}>
            <div
                onClick={handleClick}
                role="presentation"
                style={{
                    position: "fixed",
                    bottom: "12px",
                    right: "15px",
                    width: "46.7px",
                    height: "87.5px",
                }}
            >
                {children}
            </div>
        </Zoom>
    );
};
